import moment from 'moment'
import _ from 'lodash'
import { EmployeePlaceholder } from '@/model/planning/EmployeePlaceholder'
import { AutomaticallyPlannedEmployee } from '@/model/planning/AutomaticallyPlannedEmployee'
import { Task } from "@/model/planning/Task";
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'

export class PlannedEmployee {
  public constructor (
    readonly id: number | undefined,
    readonly name: string,
    readonly capacity: string | undefined,
    readonly isFloater: boolean,
    readonly competenceName: string,
    readonly educationName: string,
    readonly start: Date,
    readonly end: Date,
    readonly planingGroupName: string | undefined,
    readonly taskName: string | undefined,
    readonly note: string | undefined,
    readonly taskId: number | undefined,
    readonly number: number | undefined,
    readonly detailID?: number,
    readonly projectId?: number
  ) {}

  public get startEnd (): string {
    const start = moment(this.start)
    const end = moment(this.end)

    return `${start.format('HH:mm')} - ${end.format('HH:mm')}`
  }

  public get isPlaceholder (): boolean {
    return !this.id
  }

  public update (task: Task|undefined, note: string|undefined): PlannedEmployee {
      return new PlannedEmployee(
        this.id,
        this.name,
        this.capacity,
        this.isFloater,
        this.competenceName,
        this.educationName,
        _.cloneDeep(this.start),
        _.cloneDeep(this.end),
        this.planingGroupName,
        task ? task.name : this.taskName,
        note !== undefined ? (note.length > 0 ? note : '') : this.note,
        task ? task.id : this.taskId,
        this.number,
        this.detailID,
        this.projectId
      )
  }

  public clearTask (): PlannedEmployee {
    return new PlannedEmployee(
      this.id,
      this.name,
      this.capacity,
      this.isFloater,
      this.competenceName,
      this.educationName,
      _.cloneDeep(this.start),
      _.cloneDeep(this.end),
      this.planingGroupName,
      undefined,
      this.note,
      undefined,
      this.number,
      this.detailID,
      this.projectId
    )
  }

  public updateStartEnd (startDate: Date|undefined, endDate: Date|undefined): PlannedEmployee {
    return new PlannedEmployee(
      this.id,
      this.name,
      this.capacity,
      this.isFloater,
      this.competenceName,
      this.educationName,
      startDate ? _.cloneDeep(startDate) : _.cloneDeep(this.start),
      endDate ? _.cloneDeep(endDate) :_.cloneDeep(this.end),
      this.planingGroupName,
      this.taskName,
      this.note,
      this.taskId,
      this.number,
      this.detailID,
      this.projectId
    )
  }

  public static createListFromEmployeeItemList(placeholderList: Array<EmployeePlaceholder|AutomaticallyPlannedEmployee>, dateStart: Date, dateEnd: Date): PlannedEmployee[] {
    return placeholderList.map((item: EmployeePlaceholder | AutomaticallyPlannedEmployee): PlannedEmployee => {
      return new PlannedEmployee(
        item.employeeId,
        item.fullName,
        undefined,
        item.isFloater,
        item.competence,
        item.education,
        item.startDate ? item.startDate : _.cloneDeep(dateStart),
        item.endDate ? item.endDate : _.cloneDeep(dateEnd),
        undefined,
        item.taskName,
        item.note,
        item.taskId,
        item.number
      )
    })
  }

  public static createFromPlaceholderAndPlannedEmployee(placeholder: EmployeePlaceholder, plannedEmployee: PlannedEmployee): PlannedEmployee {
    return new PlannedEmployee(
      placeholder.employeeId,
      placeholder.fullName,
      placeholder.kapacity,
      placeholder.isFloater,
      placeholder.competence,
      placeholder.education,
      _.cloneDeep(plannedEmployee.start),
      _.cloneDeep(plannedEmployee.end),
      plannedEmployee.planingGroupName,
      placeholder.taskName,
      placeholder.note,
      placeholder.taskId,
      placeholder.number
    )
  }

  public static createListFromAutoPlannedEmployees(autoPlannedEmployees: AutomaticallyPlannedEmployee[], availableEmployeeList?: EmployeeAvailableForPlanning[]) {
    return autoPlannedEmployees.map((item: AutomaticallyPlannedEmployee) => {
    /*let planningGroupName = undefined
      if(availableEmployeeList) {
        const employee = availableEmployeeList.find((employee: EmployeeAvailableForPlanning) => employee.id === item.employeeId)
        planningGroupName = employee ? employee.planingGroupName : undefined
      }*/
        return new PlannedEmployee(
          item.employeeId,
          item.fullName,
          item.kapacity,
          item.isFloater,
          item.competence,
          item.education,
          _.cloneDeep(item.startDate),
          _.cloneDeep(item.endDate),
          item.planningGroupName ? item.planningGroupName : undefined,
          item.taskName,
          item.note,
          item.taskId,
          item.number,
          item.detailID
        )
    })
  }
}
